var exports = {
  "kL": "ProfileTypeSelector.module__container___TjRFVV",
  "r9": "ProfileTypeSelector.module__disabled___TjRFVV",
  "h_": "ProfileTypeSelector.module__description___TjRFVV",
  "By": "ProfileTypeSelector.module__guildOption___TjRFVV",
  "mN": "ProfileTypeSelector.module__guildOptionGlobal___TjRFVV",
  "XN": "ProfileTypeSelector.module__guildAvatar___TjRFVV",
  "oM": "ProfileTypeSelector.module__guildAvatarPlaceholder___TjRFVV",
  "p2": "ProfileTypeSelector.module__guildOptionLabel___TjRFVV",
};

module.exports = exports;
